module.exports = __webpack_public_path__ + "img/9fdba5ceafcc3f96a4b9042b6727c12e.d5af3fe1.jpg";